import {
  TEDGAVanvardLastMarkeringEnum,
  TEDGAVanvardVANVARDSMARKERINGEnum,
} from '../../../../../../globalQueryTypes';
import { GravplatsQuery_node_TEDGAGrav__Associations_Vanvard_All as IVanvardItem } from '../Queries/_QueryTypes/GravplatsQuery';

export const getVanvardsmarkeringLabel = (
  markering: TEDGAVanvardVANVARDSMARKERINGEnum | null
): string => {
  switch (markering) {
    case TEDGAVanvardVANVARDSMARKERINGEnum.GODKAND:
      return 'Godkänd';
    case TEDGAVanvardVANVARDSMARKERINGEnum.VANVARD_1:
      return 'Vanvård 1';
    case TEDGAVanvardVANVARDSMARKERINGEnum.VANVARD_2:
      return 'Vanvård 2';
    case TEDGAVanvardVANVARDSMARKERINGEnum.VANVARD_3:
      return 'Vanvård 3';
    case TEDGAVanvardVANVARDSMARKERINGEnum.GRAVRATTEN_FORVERKAD:
      return 'Gravrätten förverkad';
    default:
      return '-';
  }
};

export const getLastVanvardsmarkeringLabel = (
  markering: TEDGAVanvardLastMarkeringEnum | null
): string => {
  switch (markering) {
    case TEDGAVanvardLastMarkeringEnum.GODKAND:
      return 'Godkänd';
    case TEDGAVanvardLastMarkeringEnum.VANVARD_AR_1:
      return 'Vanvård 1';
    case TEDGAVanvardLastMarkeringEnum.VANVARD_AR_2:
      return 'Vanvård 2';
    case TEDGAVanvardLastMarkeringEnum.VANVARD_AR_3:
      return 'Vanvård 3';
    case TEDGAVanvardLastMarkeringEnum.GRAVRATTEN_FORVERKAD:
      return 'Gravrätten förverkad';
    default:
      return '-';
  }
};

// ** Finns bättre sätt att filtrera historik? Hittade inget som kändes uppenbart? **
// Filtreringsfunktion för historik
export const getAktuellaVanvard = (items: IVanvardItem[]): IVanvardItem[] => {
  if (items.length === 0) return [];

  const sistaGodkand = items
    .filter(
      item =>
        item.VANVARDSMARKERING === TEDGAVanvardVANVARDSMARKERINGEnum.GODKAND
    )
    .sort((a, b) => (b.LOPNR ?? 0) - (a.LOPNR ?? 0))[0];

  const sistaGodkandLopnr = sistaGodkand?.LOPNR ?? 0;

  const itemsAfterGodkand = items.filter(
    item => (item.LOPNR ?? 0) > sistaGodkandLopnr
  );

  if (itemsAfterGodkand.length === 0 && sistaGodkand) {
    return [sistaGodkand];
  }

  return itemsAfterGodkand;
};
